import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'app-headerbar',
    templateUrl: 'headerbar.component.html',
    styleUrls: ['headerbar.component.css']
})
export class HeaderbarComponent {
    public _title: string;
    @Input()
    set title(title: string) {
        this._title = title;
    }
    get title(): string {
        return this._title;
    }

    constructor() {}

}



// WEBPACK FOOTER //
// ./src/app/components/headerbar/headerbar.component.ts